import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface InvoiceListIssuedAtCellProps
  extends CellContext<InvoiceModel, InvoiceModel['issuedAt']> {}

export const InvoiceListIssuedAtCell = (
  props: InvoiceListIssuedAtCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////
  return (
    <Text truncate>{getValue() ? formatDate(getValue()!, i18n) : '-'}</Text>
  );
};
